/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  CURRENT_ACCESS_SS_KEY,
  DEFAULT_ACCESS_LS_KEY,
} from '../constants/defaultAccessConstants';

// TODO: Criar utils para funções de salvar, pegar e remover itens do local storage
export const setDefaultAccess = async (user: any) => {
  if (typeof window === 'undefined' || !sessionStorage) return;

  let formattedDefaultAccess = user;

  if (typeof user !== 'string') {
    formattedDefaultAccess = JSON.stringify(user);
  }

  try {
    localStorage.setItem(DEFAULT_ACCESS_LS_KEY, formattedDefaultAccess);
  } catch (error) {
    console.error('Default access local storage save error. ', error);
  }
};

export const getDefaultAccess = () => {
  if (typeof window === 'undefined' || !sessionStorage) return;
  if (!localStorage) return;

  const localStorageValue: string | null = localStorage.getItem(
    DEFAULT_ACCESS_LS_KEY,
  );

  if (!localStorageValue) return;

  try {
    const parsedCookieValue = JSON.parse(localStorageValue);

    if (parsedCookieValue) {
      return parsedCookieValue;
    }
  } catch (error) {
    console.error('Default access local storage parse error. ', error);
  }
};

export const removeDefaultAccess = () => {
  if (typeof window === 'undefined' || !localStorage) return;

  try {
    localStorage.removeItem(DEFAULT_ACCESS_LS_KEY);
  } catch (error) {
    console.error('Default access local storage remove error. ', error);
  }
};

export const setCurrentAccess = (user: any) => {
  if (typeof window === 'undefined' || !sessionStorage) return;

  let formattedDefaultAccess = user;

  if (typeof user !== 'string') {
    formattedDefaultAccess = JSON.stringify(user);
  }

  try {
    sessionStorage.setItem(CURRENT_ACCESS_SS_KEY, formattedDefaultAccess);
  } catch (error) {
    console.error('Default access local storage save error. ', error);
  }
};

export const getCurrentAccess = () => {
  if (typeof window === 'undefined' || !sessionStorage) return;

  const sessionStorageValue: string | null = sessionStorage.getItem(
    CURRENT_ACCESS_SS_KEY,
  );

  if (!sessionStorageValue) return;

  try {
    const parsedCookieValue = JSON.parse(sessionStorageValue);

    if (parsedCookieValue) {
      return parsedCookieValue;
    }
  } catch (error) {
    console.error('Default access local storage parse error. ', error);
  }
};

export const removeCurrentAccess = () => {
  if (typeof window === 'undefined' || !sessionStorage) return;

  try {
    sessionStorage.removeItem(CURRENT_ACCESS_SS_KEY);
  } catch (error) {
    console.error('Default access local storage remove error. ', error);
  }
};
